import { Assets } from './Assets'

export const AllIncomes = ({ incomes, handleOnClick }) => {
  const allIncomes = incomes || []
  return (
    <Assets
      assets={allIncomes}
      handleOnClick={handleOnClick}
      category={'AllIncomes'}
    />
  )
}
